import React from 'react';

function SvgEchIconsUxWindEnergy(props: React.SVGProps<SVGSVGElement>) {
  const iconUuid = React.useId();

  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100" {...props}>
      <g>
        <linearGradient
          id={`${iconUuid}_a`}
          x1={57.546}
          x2={23.546}
          y1={108.433}
          y2={15.018}
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0} stopColor="#ec6508" />
          <stop offset={1} stopColor="#f3921c" />
        </linearGradient>
        <path
          fill={`url(#${iconUuid}_a)`}
          d="M100 93l-.5-4.9c-1.2-10.9-7.6-20.8-17.1-26.3-8.7-5-19.2-6-28.7-2.7v-55l-4 2.9c-8.9 6.5-14.2 17-14.2 28 0 10.1 4.4 19.6 12 26.2L-.1 88.6l4.5 2c4.4 2 9.2 2.9 14 2.9 6 0 12-1.6 17.3-4.6 8.7-5 14.7-13.6 16.7-23.4L100 93zM79.8 66.2c6.6 3.8 11.4 10 13.6 17.3L58.1 63c7.3-1.7 15.1-.7 21.7 3.2zM40.5 34.9c0-7.6 3-14.9 8.2-20.4v40.8c-5.2-5.4-8.2-12.8-8.2-20.4zm-7.2 49.6c-6.6 3.8-14.4 4.9-21.8 3.1l35.3-20.4c-2.1 7.3-6.9 13.5-13.5 17.3z"
        />
      </g>
    </svg>
  );
}
export default SvgEchIconsUxWindEnergy;
